import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { MInitMiddleware } from '@core/routes/middleware'
import ActivityBasedTimer from '@/services/ActivityBasedTimer'
import {GlobalRoutes} from '@core/routes'
import fetch from "node-fetch";
const versioningTimer = new ActivityBasedTimer()
import routeList from './routeList'

/**
 * Does not allow vue to use vue router if the env is test
 */
if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

/**
 *  Removing routes for some domains
 *  it calls only once when site loads or reloads
 * 
 *  fetch the hostname name
 *  find if hostname name exists in the removedPlatform array in meta field of route
 *  if hostname matches, remove the path from routelist and it will load legacy page
 */

let hostname = window.location.hostname
routeList.forEach(route => {
  if(route.meta && route.meta.removedPlatform){
    let index = route.meta.removedPlatform.findIndex(domain => domain === hostname)
    if(index !== -1){
      let routeIndex = routeList.findIndex(x=> x===route)
      routeList.splice(routeIndex,1)
    }
  }
});

// remove route function ends here...

const ROUTER_BASE_URL = process.env.BASE_URL.replace('/unified','')

const router = new Router({
  mode: 'history',
  base: ROUTER_BASE_URL,
  routes: [
    ...GlobalRoutes,
    ...routeList
  ],
})

let mainTitle = "Maropost Enterprise"
/* fetch robots.txt(smallest file) after reload to compare */
let previousTimeStamp = 0
/* callback function excutes after interval */
const callback = () => {
  fetch(window.location.origin + "/robots.txt",
    { cache: 'reload', credentials: 'include' })
    .then((response) => {
      const timeStamp = new Date(response.headers.get('Last-Modified')).getTime()
      if (response.status !== 200) {
        throw new Error("offline")
      } else {
        if (!previousTimeStamp) {
          previousTimeStamp = timeStamp
          caches.keys().then(function (cacheKeys) {
            cacheKeys.forEach((cacheKey) => {
              caches.open(cacheKey).then(function (cache) {
                cache.delete('/robots.txt');
              })
            })
          })
        }
        /* differnece between two deployment's timestamp should be greater than 15 mins */
        if (timeStamp - previousTimeStamp > 900000) {
          store.commit('ui/updateAvailable', true)
          previousTimeStamp = timeStamp
        }
        return response.text()
      }
    }).catch(err => {
      /* do nothing */
    });
}
/* fetch index html after reload to compare */
callback()

versioningTimer.setInterval({
  callback,
  /* Normal interval is once every 1 minute */
  interval: 1000 * 60,
  /* Forced interval is once per 2 hour */
  forcedInterval: 1000 * 60 * 60 * 2,
});

router.afterEach((to)=>{
  const keycloak = Vue.prototype.$keycloak
  const loggedIn = (keycloak && keycloak.authenticated) ? keycloak.authenticated : false
  if(loggedIn){
    let account = store.getters['auth/account']
    if(account.current 
        && "visible_menus" in account.current 
        && !account.current.active){
      store.commit('ui/snackbar',{
        message : "This account has been disabled. Please contact support@maropost.com",
        type: 'error'
      })
    }
  }
  let title = mainTitle;
  if (to.name) {
    title = mainTitle + ' - ' + to.name.replace(/_/g,' ');
  }
  if (to.meta.layout !== undefined) {
    store.commit('ui/layout', to.meta.layout)
    document.title = title
  } else if (loggedIn) {
    store.commit('ui/layout', 'Dashboard')
    document.title = store.getters['ui/notifications'].unread > 0
      ? '(' + store.getters['ui/notifications'].unread.toLocaleString() + ') ' + title
      : title;
  } else {
    store.commit('ui/layout', 'Default')
    document.title = title
  }
})
router.beforeEach((to, _from, next) => {
  versioningTimer.runTimersCheck()
  store.commit('ui/loader.iframe', false)
  store.commit('ui/chat', true)
  store.commit('ui/folder.externalElement', { id: null, type: '', name: '' })
  /*** Reset Snackbar if true */
  if(to.meta.resetSnackbar){
    store.commit('ui/snackbar.reset')
  }
  const keycloak = Vue.prototype.$keycloak
  const loggedIn = (keycloak && keycloak.authenticated) ? keycloak.authenticated : false
  /*
  * ===== Verfication Ends ========
  */
  //disable_account_check is used to remove all the checks of account and open the page everytime
  if(to.meta.disable_account_check){
    next()
    return;
  }
  if(to.params.editAccountId !== undefined){
    store.commit('auth/editAccountId', to.params.editAccountId)
  }
  else{
    store.commit('auth/editAccountId', '')
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    store.state.auth.requestedUrl = to.path
    /* This condition only executes in the case of shopify to maropost Integrations */
    if(to.query.installation_type && to.query.crm_id){
      store.state.auth.requestedUrlQuery = to.query
    }
    next()
    return
  } else if (
    !to.matched.some(record => record.meta.requiresAuth) &&
    loggedIn &&
    to.path !== '/404' &&
    to.path !== '/access-denied' &&
    to.path !== '/app-denied' && 
    to.name !== 'AppDenied'
  ) {
    next('/accounts/' + store.getters['auth/account'].id + '/dashboard')
    return
  } 
    store.commit('auth/account.id', to.params.accountId)

  if (to.meta.chat !== undefined && to.meta.chat === false) {
    store.commit('ui/chat', false)
  }
  if (to.meta.folder_type !== undefined && to.meta.folder_type.trim() !== '') {
    let last_folder_type = store.state.ui.folder.type;
    if (to.meta.folder_type != store.state.ui.folder.lastSavedValue) {
      store.commit('ui/folder.lastSavedValue', null);
    }
    if (store.state.ui.folder.lastSavedValue) {
      last_folder_type = store.state.ui.folder.lastSavedValue;
      store.commit('ui/folder.type', last_folder_type)
    } else {
      store.commit('ui/folder.type', to.meta.folder_type)
    }
    store.commit('ui/folder.show', store.state.ui.folder.lock)
    if (store.state.ui.folder.lock) {
      store.state.ui.leftmenu = true
    }
    if (last_folder_type !== to.meta.folder_type) {
      store.commit('ui/folder.id', null)
    }
  } else {
    /**
     * NOTE: "childRouteWithinFolder" key checks if this is a child route belongs to any
     * parent route that has the folder structure in it. e.g. - /campaigns
     *
     * "lastSavedValue" is the key save in store.ui.folder to persist the last folder type selected
     * in case a user navigates to a child route (folder type set to false).
     */
    if (store.state.ui.folder.type !== to.meta.folder_type && !to.meta.childRouteWithinFolder) {
      store.commit('ui/folder.id', null)
    }
    if (to.meta.childRouteWithinFolder) {
      if (!store.state.ui.folder.lastSavedValue) {
        store.commit('ui/folder.lastSavedValue', store.state.ui.folder.type);
      }
    } else {
      store.commit('ui/folder.lastSavedValue', null)
    }
    store.commit('ui/folder.type', false)
  }
  if(store.getters['auth/isFreeTrial']){
    const setting = store.state.auth.packageFeatures.account_setting
    const list = setting && setting.package_feature
    let noAccessList = list && Object.keys(list).filter(i => list[i] === 'no');
    if(to.meta.section && noAccessList.includes(to.meta.section)){
      router.push({ path: '/error-460', query: {titleName: to.name} })
      return ;
    } 
  }
  
  //Below code redirects to access-denied page
  if(loggedIn){
    if("packageFeatures" in store.state.auth 
        && store.state.auth.packageFeatures
        && "account_setting" in  store.state.auth.packageFeatures
        && store.state.auth.packageFeatures.account_setting
        && "package_type" in store.state.auth.packageFeatures.account_setting
        && store.state.auth.packageFeatures.account_setting.package_type === "essentials"){
      if(to.path.includes("relational_tables")){
        next('/access-denied')
        return
      }
    }
  }

  //handle erfm report route
  if(to.path.includes('erfm')){
    const setting = store.getters['auth/packageFeatures']
    if(setting.account_setting){
      if(setting.account_setting.erfm_enabled){
        next();
        return;
      }
      next('/access-denied')
      return
    }
    next('/access-denied')
    return
  }

  //need to create a generic one
  if (to.meta.childRouteWithinFolder === "campaign" && !store.state.auth.roles.includes("campaigns")) {
    next('/access-denied')
    return
  }

  //check module permission
  if (to.meta.module && to.meta.module !== "mobileProfile" && !store.getters['auth/checkRole'](to.meta.module)) {
    next('/access-denied')
    return
  }

  //check mobile module permission only
  else if (to.meta.module === "mobileProfile" && !store.getters['auth/checkMobileOnly']("mobile")) {
    next('/access-denied')
    return
  }

  /*** 
   * Reset returnFromContent=false
   * if happy flow is not followed 
   */
  if(_from.path.includes("/contents/") && to.name !== "New_Journey_Template"){
    let isContent = to.path.includes("/contents/") || to.path.includes("/content_templates/");
    if(!isContent  && store.getters['journey/returnFromContent']){
      store.commit('journey/returnFromContent', false)
      store.commit('journey/workflow', {})
    }
  }
  /**
   * Reset acquisition template 
   * if redirection is not for acquisition create 
   */
  if(to.name !== 'Acquisition_forms_create'){
    store.commit('acquisition/setTemplateFormId','');
  }
  /*** 
   * Reset worflow to blank
   * i.e, Journey Step 1 data and
   * Reset returnFromStore=false
   * If redirection is not for Journey Templates 
   */
  if(_from.name === 'Integrations_index' && to.name !== 'New_Journey_Template'){
    store.commit('journey/workflow', {})
    store.commit('journey/returnFromStore', false)
  }
  
  if(_from.name === 'New_Journey_Template' && store.getters["journey/workflow"].name !== undefined){
    if(to.name === 'Integrations_index' || to.name === 'Content_templates' || to.name === 'Create_list'){
      /*** Will be managed later */
    }
    else{
      store.commit('journey/workflow', {})
    }
  }
  
  if((_from.name === null || _from.name === 'New_journey') && to.name === 'New_Journey_Template'){
    store.commit('journey/workflow', {})
    store.commit('journey/returnFromStore', false)
  }
  
  next()
})

MInitMiddleware(router)

export default router